import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import axios from "../../api/axiosService";
import FadeInSection from "../../Components/FadeInSection";
import Skeleton from "../../Components/Skeleton";
import dayjs from "dayjs";

const NEWS_SKELETON_COUNT = 6;

function News(props) {
  const { t, i18n } = useTranslation();
  const [news, setNews] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const getNews = async (keyword = "") => {
    setIsLoading(true);
    try {
      const response = await axios.get(`/api/news/list?search=${keyword}`);
      setNews(response.data.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (event) => {
    if (event.key === "Enter") {
      getNews(keyword);
    }
  };

  useEffect(() => {
    getNews();
  }, []);

  const renderNewsSkeletons = () =>
    Array.from({ length: NEWS_SKELETON_COUNT }).map((_, index) => (
      <div key={`news-skeleton-${index}`} className="new-info h-full">
        <div className="flex flex-col h-full relative md:px-2 md:py-2">
          <Skeleton className="w-[90vw] md:w-[22vw] md:h-[20.5vw] aspect-square overflow-hidden" />
          <Skeleton.Text className="w-1/3 h-4 mt-3" />
          <div className="w-[90vw] md:w-[22vw] mt-[5px] md:mt-[20px] flex flex-col gap-2">
            <Skeleton.Text className="w-full h-5" />
            <Skeleton.Text className="w-[92%] h-5" />
            <Skeleton.Text className="w-[70%] h-5" />
          </div>
        </div>
      </div>
    ));

  return (
    <div className="news-ssg w-100">
      {/* Header section */}
      <div className="news-header global-header-block-2">
        <FadeInSection direction="down">
          <div className="news-text normal-text">{t("NEWS")}</div>
          <h1 className="news-title global-title-margin title-1">
            {" "}
            {t("SSL_NEWS")}
          </h1>
        </FadeInSection>
      </div>

      <div className="relative w-[86%] md:w-full h-full md:h-[49px] max-w-[490px] px-[20px] md:px-0 mb-[50px] md:mb-[150px]">
        <FadeInSection delay={200}>
          <input
            id="search"
            type="text"
            placeholder="Search"
            className="search-bar w-full h-full md:w-[490px] md:h-[49px] max-w-[700px] max-h-[49px] border border-gray-300 rounded-none py-[15px] px-[20px] pr-12 focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            onKeyDown={handleSearch}
          />
          <div className="absolute inset-y-0 right-[0px] flex items-center pr-[20px] pointer-events-none">
            <svg
              className="w-[26px] h-[26px] text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z"
              />
            </svg>
          </div>
        </FadeInSection>
      </div>
      <div className="w-fit mx-8 md:mx-auto md:px-20 grid grid-cols-1 md:grid-cols-3 bg-white gap-[20px] md:gap-[100px]">
        {isLoading
          ? renderNewsSkeletons()
          : news.map((data, index) => (
              <FadeInSection key={data.id || index} delay={100 * (index % 3)}>
                <a
                  href={data.url}
                  target="_blank"
                  style={{ width: "fit-content" }}
                  rel="noopener noreferrer"
                  className="block new-info h-full"
                >
                  <div className="h-full">
                    <div className="border border-transparent hover:border-teal-500 hover:text-teal-500 flex flex-col justify-between h-full relative md:px-2 md:py-2">
                      <img
                        src={data.image}
                        alt={
                          String(i18n.language || "vi")
                            .toLowerCase()
                            .startsWith("vi")
                            ? data.title_VN
                            : data.title_ENG || data.title_VN
                        }
                        className="w-full h-full object-cover aspect-square w-[90vw] md:w-[22vw] md:h-[20.5vw] overflow-hidden"
                      />
                      <p className="article-date text-gray-500 normal-text">
                        {dayjs(data.createdAt).format("DD/MM/YYYY")}
                      </p>
                      <h3 className="w-full w-[90vw] md:w-[22vw] article-title font-semibold line-clamp-3 overflow-hidden uppercase mt-[5px] md:mt-[20px] normal-text">
                        {String(i18n.language || "vi")
                          .toLowerCase()
                          .startsWith("vi")
                          ? data.title_VN
                          : data.title_ENG || data.title_VN}
                      </h3>
                    </div>
                  </div>
                </a>
              </FadeInSection>
            ))}
      </div>
    </div>
  );
}

export default News;
